import React, { useEffect, useState } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import axios from 'axios';
import TradingLedger from './TradingLedger';
import IstClock from './IstClock';
import { formatIstDateKey, isIstToday, useIstClock } from './ist-datetime';
import './NormalTrading.css';
import './TradingLedgerPage.css';

const LEDGER_META = {
  normal: {
    title: 'Normal Trading Ledger',
    subtitle: (today) => `Stock trades & Groww mirror — today ${today || '—'}`,
    statusPath: '/api/normal/status',
    pageClass: 'tlp-normal'
  },
  options: {
    title: 'Options Trading Ledger',
    subtitle: (today) => `NIFTY options bot only — today ${today || '—'}`,
    statusPath: '/api/automation/status',
    pageClass: 'tlp-options'
  },
  cnc: {
    title: 'CNC Delivery Ledger',
    subtitle: (today) => `CNC delivery paper trades — today ${today || '—'}`,
    statusPath: '/api/cnc-degen/health',
    pageClass: 'tlp-cnc'
  }
};

export default function TradingLedgerPage() {
  const { mode } = useParams();
  const ledgerType = LEDGER_META[mode] ? mode : null;
  const meta = LEDGER_META[ledgerType] || LEDGER_META.normal;
  const [todayDate, setTodayDate] = useState(new Date().toISOString().slice(0, 10));
  const liveNow = useIstClock();
  const todayLabel = todayDate ? (isIstToday(todayDate) ? liveNow : formatIstDateKey(todayDate)) : '';

  useEffect(() => {
    if (!ledgerType) return;
    axios.get(meta.statusPath)
      .then((res) => {
        if (res.data?.todayDate) setTodayDate(res.data.todayDate);
      })
      .catch(() => {});
  }, [ledgerType, meta.statusPath]);

  if (!ledgerType) {
    return <Navigate to="/ledger/normal" replace />;
  }

  return (
    <div className={`nt-desktop tlp-page nt-no-sidebar ${meta.pageClass}`}>
      <main className="nt-main tlp-main">
        <header className="nt-header nt-header-compact">
          <div className="nt-header-left">
            <h1 className="tlp-title">{meta.title}</h1>
            <p className="tlp-subtitle">{meta.subtitle(todayLabel)}</p>
            <nav className="tlp-ledger-tabs" aria-label="Ledger type">
              <Link to="/ledger/normal" className={`tlp-ledger-tab${ledgerType === 'normal' ? ' active' : ''}`}>
                Normal Ledger
              </Link>
              <Link to="/ledger/options" className={`tlp-ledger-tab${ledgerType === 'options' ? ' active' : ''}`}>
                Options Ledger
              </Link>
              <Link to="/ledger/cnc" className={`tlp-ledger-tab${ledgerType === 'cnc' ? ' active' : ''}`}>
                CNC Delivery Ledger
              </Link>
            </nav>
          </div>
          <IstClock />
        </header>

        <TradingLedger defaultDate={todayDate} fullPage ledgerType={ledgerType} />
      </main>
    </div>
  );
}
